var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { ActionsColumn } from "@/components/ActionButons";
import { ListActions } from "@/components/ListActions";
import { ResourceListStyles } from "@/components/styles/ResourceListStyles";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button, styled, Typography } from "@mui/material";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { DatagridConfigurable, FunctionField, List, SelectInput, TextField, TextInput, useGetList, useGetOne, useListContext, useNotify, useRefresh, WrapperField, } from "react-admin";
import { useTranslation } from "react-i18next";
import { useTenantStore } from "@/providers/TenantContextProvider";
import CreateEvent, { EventProcessors } from "./CreateScheduledEvent";
import { Dialog } from "@sequentech/ui-essentials";
import AddIcon from "@mui/icons-material/Add";
import UploadIcon from "@mui/icons-material/Upload";
import { IPermissions } from "@/types/keycloak";
import { useMutation } from "@apollo/client";
import { MANAGE_ELECTION_DATES } from "@/queries/ManageElectionDates";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
import ElectionHeader from "@/components/ElectionHeader";
import { useScheduledEventPermissions } from "../ElectionEvent/useScheduledEventPermissions";
import { getGraphQLActionErrorReason } from "@/services/graphqlActionError";
import { ThreeStateDatagridHeader } from "@/components/ThreeStateDatagridHeader";
import { useQuery } from "@apollo/client";
import { Chip, Stack } from "@mui/material";
import { ZonedDateTime, hasOffset } from "@/components/timezones/ZonedDateTime";
import { useTimeZoneContext } from "@/components/timezones/useTimeZoneContext";
import { EXPORT_SCHEDULE, GET_LIFECYCLE_SNAPSHOTS, GET_SCHEDULED_OUTCOMES, } from "@/queries/Lifecycle";
import { DownloadDocument } from "@/resources/User/DownloadDocument";
import { isVotingTransition } from "./CreateScheduledEvent";
import { ACTIVE_SCHEDULED_EVENTS } from "@/services/ScheduledEvent";
import { ScheduleBanners, outcomeFilterIds, outcomesByRow, outcomesForElection, } from "./ScheduleBanners";
import { RowOutcome } from "./RowOutcome";
import { WARNING_TEXT } from "@/components/timezones/ScheduledOutcome";
import { ImportScheduleDrawer } from "./ImportScheduleDrawer";
import { unpublishedEventIds } from "./unpublishedChanges";
export var DataGridContainerStyle = styled(DatagridConfigurable)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media (min-width: ", "px) {\n        width: 100%;\n        ", "\n        &  > div:first-child {\n            position: absolute;\n            width: 100%;\n        }\n    }\n"], ["\n    @media (min-width: ", "px) {\n        width: 100%;\n        ", "\n        &  > div:first-child {\n            position: absolute;\n            width: 100%;\n        }\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.values.md;
}, function (_a) {
    var isOpenSideBar = _a.isOpenSideBar;
    return "max-width: ".concat(isOpenSideBar ? "calc(100vw - 355px)" : "calc(100vw - 108px)", ";");
});
var FilterWatcher = function (_a) {
    var fieldName = _a.fieldName, onFilterChange = _a.onFilterChange;
    var filterValues = useListContext().filterValues;
    var previousFilters = useRef(filterValues);
    useEffect(function () {
        // Check which filters were removed
        Object.keys(previousFilters.current).forEach(function (key) {
            if (!(key in filterValues)) {
                if (key === fieldName) {
                    onFilterChange();
                }
            }
        });
        previousFilters.current = filterValues;
    }, [filterValues]);
    return null;
};
var ListScheduledEvents = function (_a) {
    var _b, _c;
    var electionEventId = _a.electionEventId;
    var t = useTranslation().t;
    var globalSettings = useContext(SettingsContext).globalSettings;
    var tenantId = useTenantStore()[0];
    var refresh = useRefresh();
    var notify = useNotify();
    var _d = useState(false), isDeleteModalOpen = _d[0], setIsDeleteModalOpen = _d[1];
    var _e = useState(), isDeleteId = _e[0], setIsDeleteId = _e[1];
    var _f = useState(false), isEditEvent = _f[0], setIsEditEvent = _f[1];
    var _g = useState(false), openCreateEvent = _g[0], setOpenCreateEvent = _g[1];
    var _h = useState(), selectedEventId = _h[0], setSelectedEventId = _h[1];
    var aliasRenderer = useAliasRenderer();
    var _j = useScheduledEventPermissions(), canWriteScheduledEvent = _j.canWriteScheduledEvent, canCreateScheduledEvent = _j.canCreateScheduledEvent, canDeleteScheduledEvent = _j.canDeleteScheduledEvent, showScheduledEventColumns = _j.showScheduledEventColumns;
    var manageElectionDates = useMutation(MANAGE_ELECTION_DATES, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.SCHEDULED_EVENT_WRITE,
            },
        },
    })[0];
    var scheduledEventToDelete = useGetOne("sequent_backend_scheduled_event", {
        id: isDeleteId,
        meta: { tenant_id: tenantId },
    }, {
        enabled: !!isDeleteId,
        refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
        refetchIntervalInBackground: true,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
    }).data;
    var elections = useGetList("sequent_backend_election", {
        pagination: { page: 1, perPage: 500 },
        sort: { field: "created_at", order: "DESC" },
        filter: {
            tenant_id: tenantId,
            election_event_id: electionEventId,
            archived_at: {
                format: "hasura-raw-query",
                value: { _is_null: true },
            },
        },
    }, {
        refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
    }).data;
    var _k = useState(null), eventScreeElectionId = _k[0], setEventScreenElectionId = _k[1];
    var electionIds = useMemo(function () {
        var _a;
        var electionsList = (_a = elections === null || elections === void 0 ? void 0 : elections.map(function (election) { return election.id; })) !== null && _a !== void 0 ? _a : [];
        if (eventScreeElectionId) {
            electionsList = electionsList.filter(function (item) { return item === eventScreeElectionId; });
        }
        return electionsList;
    }, [elections, eventScreeElectionId]);
    var electionIdOf = function (scheduledEvent) {
        var _a, _b;
        return (_b = (_a = scheduledEvent === null || scheduledEvent === void 0 ? void 0 : scheduledEvent.event_payload) === null || _a === void 0 ? void 0 : _a.election_id) !== null && _b !== void 0 ? _b : null;
    };
    // Event-wide rows have no election: they read "All elections".
    var getElectionName = function (scheduledEvent) {
        var electionId = electionIdOf(scheduledEvent);
        if (!electionId)
            return t("lifecycle.schedule.allElections");
        var foundElection = elections === null || elections === void 0 ? void 0 : elections.find(function (item) { return electionId === item.id; });
        return (foundElection && aliasRenderer(foundElection)) || "-";
    };
    var zones = useTimeZoneContext(electionEventId);
    // The entered wall time and zone remain in cron_config for editing; the
    // list displays that same instant in its Post's zone (or the event primary).
    var zoneOfRow = function (scheduledEvent) {
        return zones.zoneOf(electionIdOf(scheduledEvent));
    };
    // What each future opening and closing will do (design §5c), and the published configuration.
    var _l = useQuery(GET_SCHEDULED_OUTCOMES, {
        context: { headers: { "x-hasura-role": IPermissions.ELECTION_EVENT_READ } },
        variables: { electionEventId: electionEventId },
        skip: !electionEventId,
        pollInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
    }), outcomesData = _l.data, outcomesError = _l.error;
    var outcomes = useMemo(function () { var _a, _b; return outcomesByRow((_b = (_a = outcomesData === null || outcomesData === void 0 ? void 0 : outcomesData.get_scheduled_outcomes) === null || _a === void 0 ? void 0 : _a.outcomes) !== null && _b !== void 0 ? _b : []); }, [outcomesData]);
    // Filtered to one election, the banners count only that election's transitions.
    var shownOutcomes = useMemo(function () { return outcomesForElection(outcomes, eventScreeElectionId); }, [outcomes, eventScreeElectionId]);
    var snapshotData = useQuery(GET_LIFECYCLE_SNAPSHOTS, {
        variables: { electionEventId: electionEventId },
        skip: !electionEventId,
    }).data;
    var publications = useMemo(function () { var _a, _b; return (_b = (_a = snapshotData === null || snapshotData === void 0 ? void 0 : snapshotData.get_lifecycle_snapshots) === null || _a === void 0 ? void 0 : _a.snapshots) !== null && _b !== void 0 ? _b : []; }, [snapshotData]);
    // Every active row of the event, for the banners' totals.
    var allScheduledEvents = useGetList("sequent_backend_scheduled_event", {
        pagination: { page: 1, perPage: 9999 },
        filter: __assign({ tenant_id: tenantId, election_event_id: electionEventId }, ACTIVE_SCHEDULED_EVENTS),
    }, { enabled: !!electionEventId, refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS }).data;
    var unpublished = useMemo(function () {
        return unpublishedEventIds(allScheduledEvents !== null && allScheduledEvents !== void 0 ? allScheduledEvents : [], publications, (elections !== null && elections !== void 0 ? elections : []).map(function (_a) {
            var id = _a.id;
            return String(id);
        }));
    }, [allScheduledEvents, publications, elections]);
    var _m = useState(null), outcomeFilter = _m[0], setOutcomeFilter = _m[1];
    var filteredIds = outcomeFilter ? outcomeFilterIds(shownOutcomes, outcomeFilter) : null;
    var _o = useState(false), openImport = _o[0], setOpenImport = _o[1];
    var _p = useState(null), exportDocumentId = _p[0], setExportDocumentId = _p[1];
    var _q = useMutation(EXPORT_SCHEDULE, { context: { headers: { "x-hasura-role": IPermissions.SCHEDULED_EVENT_WRITE } } }), exportSchedule = _q[0], exporting = _q[1].loading;
    var doExport = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, documentId, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, exportSchedule({ variables: { electionEventId: electionEventId } })];
                case 1:
                    data = (_c.sent()).data;
                    documentId = (_a = data === null || data === void 0 ? void 0 : data.export_schedule) === null || _a === void 0 ? void 0 : _a.document_id;
                    if (!documentId)
                        throw new Error("No document");
                    setExportDocumentId(documentId);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _c.sent();
                    notify((_b = getGraphQLActionErrorReason(error_1)) !== null && _b !== void 0 ? _b : t("lifecycle.schedule.exportError"), {
                        type: "error",
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var OMIT_FIELDS = ["id"];
    var editAction = function (id) {
        setOpenCreateEvent(true);
        setIsEditEvent(true);
        setSelectedEventId(id);
    };
    var handleClose = function () {
        setOpenCreateEvent(false);
        setIsEditEvent(false);
    };
    var confirmDeleteAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, variables, errors, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!scheduledEventToDelete) return [3 /*break*/, 4];
                    payload = scheduledEventToDelete.event_payload;
                    if (!(scheduledEventToDelete.election_event_id &&
                        scheduledEventToDelete.event_processor)) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    variables = {
                        electionEventId: scheduledEventToDelete.election_event_id,
                        electionId: payload === null || payload === void 0 ? void 0 : payload.election_id,
                        scheduledDate: undefined, // to archive, set date to undefined
                        eventProcessor: scheduledEventToDelete.event_processor,
                    };
                    return [4 /*yield*/, manageElectionDates({
                            variables: variables,
                        })];
                case 2:
                    errors = (_a.sent()).errors;
                    if (errors) {
                        console.error(errors);
                        notify(t("eventsScreen.messages.editError"), { type: "error" });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error(error_2);
                    notify(t("eventsScreen.messages.editError"), { type: "error" });
                    return [3 /*break*/, 4];
                case 4:
                    refresh();
                    setIsDeleteModalOpen(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var deleteAction = function (id) {
        setIsDeleteId(id);
        setIsDeleteModalOpen(true);
        setOpenCreateEvent(false);
    };
    var actions = [
        {
            icon: _jsx(EditIcon, { className: "edit-voter-icon" }),
            action: function (id) { return editAction(id); },
            showAction: function () { return canWriteScheduledEvent; },
        },
        {
            icon: _jsx(DeleteIcon, { className: "delete-voter-icon" }),
            action: function (id) { return deleteAction(id); },
            showAction: function () { return canDeleteScheduledEvent; },
            label: t("common.label.delete"),
            className: "delete-voter-icon",
        },
    ];
    var onOpenDrawer = function () {
        setOpenCreateEvent(!openCreateEvent);
    };
    var Empty = function () { return (_jsxs(ResourceListStyles.EmptyBox, { children: [_jsx(Typography, { variant: "h4", paragraph: true, children: t("eventsScreen.empty.header") }), canCreateScheduledEvent || canWriteScheduledEvent ? (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body1", paragraph: true, children: t("eventsScreen.empty.body") }), _jsxs(Stack, { direction: "row", sx: { gap: 1, flexWrap: "wrap", justifyContent: "center" }, children: [canCreateScheduledEvent ? (_jsx(Button, { startIcon: _jsx(AddIcon, {}), onClick: function () { return setOpenCreateEvent(true); }, children: t("eventsScreen.empty.button") })) : null, canWriteScheduledEvent ? (_jsx(Button, { variant: "secondary", startIcon: _jsx(UploadIcon, {}), onClick: function () { return setOpenImport(true); }, children: t("common.label.import") })) : null] })] })) : null] })); };
    // Define the filters as an array of elements
    var Filters = [
        _jsx(SelectInput, { source: "event_processor", label: String(t("eventsScreen.fields.eventProcessor")), choices: Object.values(EventProcessors).map(function (eventType) { return ({
                id: eventType,
                name: t("eventsScreen.eventType.".concat(eventType)),
            }); }) }, "event_processor_filter"),
        _jsx(SelectInput, { source: "event_payload.election_id", label: String(t("eventsScreen.fields.electionId")), choices: elections === null || elections === void 0 ? void 0 : elections.map(function (election) { return ({
                id: election.id,
                name: aliasRenderer(election),
            }); }), onChange: function (e) {
                setEventScreenElectionId(e.target.value);
            } }, "election_id_filter"),
        _jsx(TextInput, { source: "id", label: "id" }, "id_filter"),
    ];
    return (_jsxs(_Fragment, { children: [_jsx(ElectionHeader, { title: String(t("eventsScreen.title")), subtitle: "eventsScreen.subtitle" }), _jsx(ScheduleBanners, { electionEventId: electionEventId, outcomes: shownOutcomes, retainedCloses: ((_c = (_b = outcomesData === null || outcomesData === void 0 ? void 0 : outcomesData.get_scheduled_outcomes) === null || _b === void 0 ? void 0 : _b.retained_closes) !== null && _c !== void 0 ? _c : []).filter(function (close) { return !eventScreeElectionId || close.election_id === eventScreeElectionId; }), retainedUnavailable: !!outcomesError, electionNameOf: function (electionId) {
                    var election = elections === null || elections === void 0 ? void 0 : elections.find(function (item) { return item.id === electionId; });
                    return election ? aliasRenderer(election) : t("eventsScreen.fields.electionId");
                }, filter: outcomeFilter, onFilter: setOutcomeFilter, unpublishedCount: unpublished.size, published: publications.length > 0, offsetless: (allScheduledEvents !== null && allScheduledEvents !== void 0 ? allScheduledEvents : []).filter(function (event) {
                    var _a;
                    var date = (_a = event.cron_config) === null || _a === void 0 ? void 0 : _a.scheduled_date;
                    return !event.stopped_at && !!date && !hasOffset(date);
                }).length, canApply: canWriteScheduledEvent, zoneOf: zones.zoneOf, scheduledEvents: allScheduledEvents !== null && allScheduledEvents !== void 0 ? allScheduledEvents : [] }), _jsx(List, { resource: "sequent_backend_scheduled_event", filter: __assign(__assign(__assign({ election_event_id: electionEventId || undefined, tenant_id: tenantId }, ACTIVE_SCHEDULED_EVENTS), { event_payload: {
                        format: "hasura-raw-query",
                        value: {
                            _contains: { election_id: electionIds },
                        },
                    } }), (filteredIds
                    ? { id: { format: "hasura-raw-query", value: { _in: filteredIds } } }
                    : {})), filters: Filters, queryOptions: {
                    refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
                }, empty: _jsx(Empty, {}), actions: _jsx(ListActions, { withColumns: showScheduledEventColumns, withImport: canWriteScheduledEvent, doImport: function () { return setOpenImport(true); }, withExport: canWriteScheduledEvent, doExport: doExport, isExportDisabled: exporting, open: openCreateEvent, setOpen: onOpenDrawer, withAction: canCreateScheduledEvent, doAction: onOpenDrawer, actionLabel: "common.label.add" }), disableSyncWithLocation: true, children: _jsxs(DatagridConfigurable, { header: ThreeStateDatagridHeader, bulkActionButtons: false, omit: OMIT_FIELDS, children: [_jsx(FilterWatcher, { fieldName: "event_payload", onFilterChange: function () { return setEventScreenElectionId(null); } }), _jsx(TextField, { source: "id" }), _jsx(FunctionField, { label: String(t("eventsScreen.fields.electionId")), source: "event_payload.election_id", sortable: false, render: getElectionName }), _jsx(FunctionField, { label: String(t("eventsScreen.fields.eventProcessor")), source: "event_processor", render: function (record) {
                                return t("eventsScreen.eventType." + record.event_processor);
                            } }), _jsx(FunctionField, { label: String(t("eventsScreen.fields.scheduledDate")), source: "cron_config.scheduled_date", sortable: false, render: function (record) {
                                var _a;
                                var date = (_a = record.cron_config) === null || _a === void 0 ? void 0 : _a.scheduled_date;
                                if (!date)
                                    return "-";
                                return (_jsxs(Stack, { spacing: 0.5, sx: { alignItems: "flex-start" }, children: [hasOffset(date) ? (_jsx(ZonedDateTime, { instant: date, zone: zoneOfRow(record) })) : (_jsxs(_Fragment, { children: [_jsx("span", { children: date }), _jsx(Chip, { size: "small", color: "warning", sx: WARNING_TEXT.warning, label: t("lifecycle.schedule.noOffset") })] })), unpublished.has(String(record.id)) ? (_jsx(Chip, { size: "small", variant: "outlined", label: t("lifecycle.schedule.unpublished") })) : null] }));
                            } }), _jsx(FunctionField, { label: String(t("eventsScreen.fields.stoppedAt")), source: "stopped_at", render: function (record) { return (_jsx(ZonedDateTime, { instant: record.stopped_at, zone: zoneOfRow(record) })); } }), _jsx(FunctionField, { label: String(t("lifecycle.schedule.outcome")), sortable: false, render: function (record) {
                                var rowOutcomes = outcomes.get(String(record.id));
                                return isVotingTransition(record.event_processor) &&
                                    !record.stopped_at &&
                                    (rowOutcomes === null || rowOutcomes === void 0 ? void 0 : rowOutcomes.length) ? (_jsx(RowOutcome, { outcomes: rowOutcomes, zone: zoneOfRow(record) })) : ("-");
                            } }), _jsx(WrapperField, { label: String(t("common.label.actions")), children: _jsx(ActionsColumn, { actions: actions }) })] }) }), _jsx(ResourceListStyles.Drawer, { anchor: "right", open: openCreateEvent, onClose: handleClose, sx: { "& .MuiDrawer-paper": { width: { xs: "100%", md: "50%" } } }, children: _jsx(CreateEvent, { electionEventId: electionEventId, setIsOpenDrawer: setOpenCreateEvent, isEditEvent: isEditEvent, selectedEventId: selectedEventId, getElectionName: getElectionName }) }), openImport ? (_jsx(ImportScheduleDrawer, { electionEventId: electionEventId, primary: zones.primary, onClose: function () { return setOpenImport(false); }, onImported: function () {
                    setOpenImport(false);
                    refresh();
                } })) : null, exportDocumentId ? (_jsx(DownloadDocument, { documentId: exportDocumentId, electionEventId: electionEventId, fileName: t("lifecycle.schedule.exportFileName"), onDownload: function () { return setExportDocumentId(null); } })) : null, _jsx(Dialog, { variant: "warning", open: isDeleteModalOpen, ok: String(t("common.label.delete")), cancel: String(t("common.label.cancel")), title: String(t("common.label.warning")), handleClose: function (result) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!result) return [3 /*break*/, 2];
                                return [4 /*yield*/, confirmDeleteAction()];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                setIsDeleteModalOpen(false);
                                return [2 /*return*/];
                        }
                    });
                }); }, children: t("eventsScreen.edit.delete") })] }));
};
export default ListScheduledEvents;
var templateObject_1;
